import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import styles from './Header.module.scss';

const cn = classNames.bind(styles);

const Header = props => {
  const headerClassname = cn(
    styles.header,
    styles[props.color],
    {
      [`${styles.shadow}`]: props.shadow
    },
    props.className
  );

  return (
    <header className={headerClassname}>
      <div className={styles.headerMenu}>
        {!!props.menuIcon && (
          <div className={styles.menuIcon}>{props.menuIcon}</div>
        )}
        <div className={styles.headerLogo}>{props.logo}</div>
        <div className={styles.headerLeftContent}>
          {props.renderLeftContent && props.renderLeftContent()}
        </div>

        <div className={props.menuIcon ? styles.menuClassname : ''}>
          {props.children}
        </div>
        <div className={styles.headerExtraContent}>
          {props.renderExtraContent && props.renderExtraContent()}
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  color: PropTypes.oneOf(['light', 'dark', 'transparent']),
  shadow: PropTypes.bool,
  className: PropTypes.string,
  logo: PropTypes.element,
  menuIcon: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.array
  ]),
  renderLeftContent: PropTypes.func,
  renderExtraContent: PropTypes.func
};

Header.defaultProps = {
  color: 'light',
  shadow: false,
  className: '',
  logo: null,
  menuIcon: null,
  renderLeftContent: () => {},
  renderExtraContent: () => {},
  children: null
};

export default Header;
